import React from 'react';
import classnames from 'classnames';
import Image from 'next/image';

import { IImage, ILink } from 'utils/types';
import { Figure } from 'components/media/Figure';
import { BackButton } from 'components/button/BackButton';

import s from './ArticleHero.module.scss';

type Props = {
  index?: number;
  tagline?: React.ReactNode;
  title?: React.ReactNode;
  text?: string;
  image?: IImage;
  link?: ILink;
  linkText?: string;
  caption?: React.ReactNode;
  back?: string;
  backLabel?: string;
  backOnClick?: (event) => void;
  date?: string;
  wide?: boolean;
};

export const ArticleHero = ({
  index,
  tagline,
  title,
  image,
  caption,
  back,
  backLabel = 'Back',
  backOnClick,
  date,
  wide,
}: Props) => {
  const info = (
    <div className={s.hero__info}>
      {tagline && <div className={s.hero__tagline}>{tagline}</div>}
      {date && <div className={s.hero__date}>{date}</div>}
    </div>
  );

  return (
    <div className={classnames(s.hero, { [s.back]: back, [s.wide]: wide })}>
      <div className={s.hero__container}>
        <div className={s.hero__content}>
          <div className={s.hero__row}>
            <div className={s.hero__column}>
              {back && (
                <div className={s.hero__back}>
                  <BackButton href={back} onClick={backOnClick}>
                    {backLabel}
                  </BackButton>
                </div>
              )}
              {!back && (tagline || date) && info}
              <h1 className={s.hero__title}>{title}</h1>
              {back && (tagline || date) && info}
            </div>
          </div>
          {image && (
            <div className={s.hero__row}>
              <div className={s.hero__imgColumn}>
                {image && (
                  <Figure className={s.hero__figure} caption={caption}>
                    <div className={s.hero__image}>
                      <Image className={s.hero__img} src={image.url} layout="fill" priority />
                    </div>
                  </Figure>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
